// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

//Services
import { AuthGuard } from "../shared/services/authGuard";
import { NavFormsService } from "../shared/services/navFormsService";

//Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//Components
import { cpdesComponent } from './components/cpdes';

//Modules
import { CappModule, CappRoutes } from '../capp/capp.module';
import { HealthCheckModule, HealthCheckRoutes } from '../health-check/health-check.module';
import { PracticesModule, PracticesRoutes } from '../practices/practices.module';
import { CometModule, CometRoutes } from '../comet/comet.module';
import { TaggingModule, TaggingRoutes } from '../tagging/tagging.module';
import { TranslationModule, TranslationRoutes } from '../translation/translation.module';
import { SharedModule } from '../shared/shared.module';



// LOCALS
//-------------------------------------------------------------------------------------------------------------------------
const routes = [
    { 
        path:"cpdes", 
        canActivate:[AuthGuard],
        component:cpdesComponent, 
        children: 
            [{ path:'', redirectTo:'practices', pathMatch:'full' }]
            .concat(HealthCheckRoutes)
            .concat(PracticesRoutes)           
            .concat(CappRoutes)
            .concat(CometRoutes)
            .concat(TaggingRoutes)
            .concat(TranslationRoutes)
    }
];


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CPDESModule
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@NgModule({
    imports : [
        
        //Angular

        //Third Party
        NgbModule,

        //CPDES
        HealthCheckModule,
        PracticesModule,
        SharedModule,

        //COMET
        CometModule,                

        //CAPP
        CappModule,

        //TAGGING
        TaggingModule,

        //TRANSLATION
        TranslationModule,

        //Routes Last
        RouterModule.forChild(routes)
    ],
    declarations:[
        cpdesComponent
    ],
    providers: [
        AuthGuard,
        NavFormsService
    ],
    exports:[ 
        RouterModule 
    ]
})
export class CPDESModule{}